// extracted by mini-css-extract-plugin
module.exports = {"htmlToReactContainer":"styles_htmlToReactContainer__IfN2_","block":"styles_block__1JFnB"};